import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { Market } from 'src/interfaces/market'
import { MarketForm } from './MarketForm'
import type { MarketFormMode, MarketFormValues } from './MarketForm.interface'

const FORM_ID = 'market-form'

interface Props {
  isOpen: boolean
  mode: MarketFormMode
  market: Market | null
  isSaving: boolean
  onSubmit(values: MarketFormValues): void
  onClose(): void
}

const MarketFormModalComponent = ({ isOpen, mode, market, isSaving, onSubmit, onClose }: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit market' : 'Add market'}
      // Wider than the default confirm-dialog width: this modal carries a form.
      className={tw`max-w-[480px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="dark"
            type="submit"
            form={FORM_ID}
            loading={isSaving}
            disabled={isSaving}
            data-testid="market-form-submit-button"
          >
            {mode === 'edit' ? 'Save changes' : 'Create market'}
          </Button>
        </Fragment>
      }
    >
      <MarketForm formId={FORM_ID} mode={mode} market={market} onSubmit={onSubmit} />
    </CommonModal>
  )
}

export const MarketFormModal = memo(MarketFormModalComponent)
